module.exports = __webpack_public_path__ + "img/logo (8).ac48be04.png";